import * as PopoverPrimitive from "@radix-ui/react-popover";
import { Check, ChevronDown } from "lucide-react";

const MultiSelect = ({ options, value = [], onChange, placeholder }) => {
  // Find names of selected IDs for the display label
  const selectedLabels = options
    .filter((opt) => value.includes(String(opt.id)))
    .map((opt) => opt.name);

  const toggleValue = (val) => {
    const newValue = value.includes(val)
      ? value.filter((v) => v !== val) // Remove if exists
      : [...value, val]; // Add if not exists
    onChange(newValue);
  };

  return (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger className="flex h-9 w-full items-center justify-between rounded-md border-[1.5px] border-[#D8C29A] bg-white px-3 py-1 text-xs hover:border-[#C9A86A] focus:outline-none dark:border-[#5c4b2e] dark:bg-[#1b1a17]">
        <span className="truncate">
          {selectedLabels.length > 0 ? selectedLabels.join(", ") : placeholder}
        </span>
        <ChevronDown className="h-4 w-4 opacity-50" />
      </PopoverPrimitive.Trigger>

      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align="start"
          className="z-50 min-w-[200px] overflow-hidden rounded-md border border-[#D8C29A] bg-white p-1 shadow-md dark:border-[#5c4b2e] dark:bg-[#1b1a17]"
        >
          <div className="max-h-60 overflow-y-auto">
            {options.map((opt) => {
              const isSelected = value.includes(String(opt.id));
              return (
                <div
                  key={opt.id}
                  onClick={() => toggleValue(String(opt.id))}
                  className={`relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-xs outline-none hover:bg-[#F7F1E6] dark:hover:bg-[#2a2925] ${
                    isSelected ? "font-bold" : ""
                  }`}
                >
                  <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
                    {isSelected && <Check className="h-4 w-4" />}
                  </span>
                  {opt.name}
                </div>
              );
            })}
          </div>
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
};

export default MultiSelect;
